/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { setSendedSearch, updateNaoIds, updateData } from "../utils/searchHelpers";

import { IconSuccess, WarningIcon2 } from "~misc/icons";
import useCliente from "~/fetchs/useCliente";
import originControl from "~services/utils/originControl";
import { useNavigate } from "react-router-dom";
import useLocalStorage from "~hooks/useLocalStorage";
import { randomId } from "~pages/Funnel/utils";
import useRequisicoesOffline from "~fetchs/useRequisicoesOffline";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";

const usePriceSearch = ({ idCliente, pesquisaObjetos, origem, cameFromVisitaView }) => {
  const [isLoadingPost, setIsLoadingPost] = useState(false);
  const [toUpdateValues, setToUpdateValues] = useState();
  const [ultimosDadosColetados, setUltimosDadosColetados] = useState({});
  const [showMessageForm, setShowMessageForm] = useState({
    text: "",
    type: "success",
    icon: IconSuccess,
  });

  const { origens } = originControl();
  const clienteId = parseInt(idCliente);

  const { save } = useRequisicoesOffline();
  const { cliente } = useCliente(idCliente);
  const { checkin } = useCheckIn();

  const [, setLocalStorage] = useLocalStorage("validation", null);
  const navigate = useNavigate();

  const checkRouteRoteirizacao = (idCliente, idClienteRota, origem) => {
    if (idClienteRota !== null && idClienteRota !== undefined) {
      setLocalStorage(idClienteRota);
      navigate(`/roteirizacao/${idClienteRota}`);
    }
  };
  const updateOnSuccess = async (response) => {
    if (response?.mapasMina) {
      const historyIds = response.historyIds ?? [];

      await updateNaoIds({ historyIds, clienteId }).then(async () => {
        await updateData({ data: response.mapasMina, resetMapaDaMina: true, clienteId });
      });
    }

    await setSendedSearch({
      clienteId,
      date: new Date(),
      data: {
        ...ultimosDadosColetados,
      },
    });

    setIsLoadingPost(false);

    setShowMessageForm({
      text: `Pesquisa atualizada com sucesso`,
      icon: IconSuccess,
      type: "success",
    });

    if (cameFromVisitaView === "true") {
      navigate(`/roteirizacao/consulta/${clienteId}`);
      return;
    }

    const history = JSON.parse(sessionStorage.getItem("rotas") || "[]");
    const lastUrl = history.at(-2) || "";
    const cameFromRoteirizacao = lastUrl.includes("/roteirizacao/");

    const shouldRedirectToRoteirizacao =
      origem === "roteirizacao" || cameFromRoteirizacao || (checkin?.clienteId && clienteId === checkin.clienteId);

    if (shouldRedirectToRoteirizacao) {
      if (checkin?.clienteId) {
        checkRouteRoteirizacao(clienteId, checkin.clienteId, origem);
      } else {
        checkRouteRoteirizacao(clienteId, clienteId, origem);
      }
    }
  };

  const updateOnError = (error) => {
    setIsLoadingPost(false);
    const message = error?.message ?? "";
    setShowMessageForm({
      text: `Ocorreu um erro durante o envio da pesquisa - ${message ?? ""}`,
      icon: WarningIcon2,
      type: "error",
    });
  };

  const handleSavePriceSearchDataChange = async () => {
    const obj = {
      id: randomId(15),
      type: "mapaDaMina",
      clienteId,
      toSend: toUpdateValues,
      createdAt: new Date().toISOString(),
      sended: false,
    };

    try {
      const response = await save(obj);

      if (response?.isOffline) {
        await setSendedSearch({
          clienteId,
          date: new Date(),
          data: {
            ...ultimosDadosColetados,
          },
        });

        if (cameFromVisitaView === "true") {
          navigate(`/roteirizacao/consulta/${clienteId}?cameFromVisitaView=true`);
        } else {
          const history = JSON.parse(sessionStorage.getItem("rotas") || "[]");
          const lastUrl = history.at(-2) || "";
          const cameFromRoteirizacao = lastUrl.includes("/roteirizacao/");

          const shouldRedirectToRoteirizacaoOffline =
            origem === "roteirizacao" ||
            cameFromRoteirizacao ||
            (checkin?.clienteId && clienteId === checkin.clienteId);

          if (shouldRedirectToRoteirizacaoOffline) {
            if (checkin?.clienteId) {
              checkRouteRoteirizacao(clienteId, checkin.clienteId, origem);
            } else {
              checkRouteRoteirizacao(clienteId, clienteId, origem);
            }
          }
        }

        setShowMessageForm({
          text: `Pesquisa atualizada com sucesso (modo offline)`,
          icon: IconSuccess,
          type: "success",
        });
        setIsLoadingPost(false);
        return;
      }

      updateOnSuccess(response);
    } catch (error) {
      updateOnError(error);
    }
  };

  useEffect(() => {
    if (toUpdateValues) {
      handleSavePriceSearchDataChange();
    }
  }, [toUpdateValues]);

  const handleSavePriceSearch = (items) => {
    setIsLoadingPost(true);
    setToUpdateValues(items);
  };

  return {
    cliente,
    handleSavePriceSearch,
    setUltimosDadosColetados,
    showMessageForm,
    setShowMessageForm,
    origens,
    isLoadingPost,
  };
};

export default usePriceSearch;
